import { CustomerBillerStoreService } from '../../../billers/services/customer-biller-store.service';
import { LiabilitySource } from '../../../billers/models/model';
import { HandsetService } from '../../../core/services/handset.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/core/services/app-config.service';
import { ToolbarService } from '../../../core/services/toolbar.service';
import { AddLiabilityScanForm } from '../../forms/add-liability-scan.form';
import { switchMap, take, tap } from 'rxjs/operators';
import { BillerSearchService } from 'src/app/billers/services/biller-search.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { AddBillerDialogComponent } from '../../components/add-biller-dialog/add-biller-dialog.component';
import { MAX_WIDTH_90, WIDTH_360 } from 'src/app/shared/configs/dialog-config';
import { LimitedCustomerBiller } from '../../models/limited-biller.model';
import { LiabilityService } from '../../services/liability.service';
import { AutomaticReadingResultData, ReadingStatus } from '../../models/automatic-reading-result-data';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { BillerService } from '../../../billers/services/biller.service';
import { AddManualLiabilityData } from '../../models/add-manual-liability-data.model';
import { HttpClient } from '@angular/common/http';
import { DeviceService } from '../../../shared/services/device.service';

@Component({
standalone: false,
  selector: 'app-liability-data-confirmation',
  templateUrl: './liability-data-confirmation.component.html',
  styleUrls: ['./liability-data-confirmation.component.scss'],
})
export class LiabilityDataConfirmationComponent implements OnInit {
  public form: AddLiabilityScanForm;
  public customerBillers: LimitedCustomerBiller[];
  public urlSafe: SafeResourceUrl;
  public url: SafeResourceUrl;
  public path: string;
  public documentPreviewVisible = false;
  public base64Src: string;
  public liabilityAutomaticReadingId: string;
  private foundBiller: string;
  public showManual: boolean;
  public readonly MIN_AMOUNT = 0.01;
  touchTimeout: any;

  initialManualDataValue: AddManualLiabilityData;
  title: string;
  subtitle: string;
  buttonText = 'Potwierdź';
  maxWidth = '516px';


  constructor(
    public appConfig: AppConfig,
    public handsetService: HandsetService,
    public deviceService: DeviceService,
    public billerSearch: BillerSearchService,
    private activatedRoute: ActivatedRoute,
    private toolbar: ToolbarService,
    private router: Router,
    private customerBillerStoreService: CustomerBillerStoreService,
    private dialog: DialogService,
    private liabilityService: LiabilityService,
    private sanitizer: DomSanitizer,
    private billerService: BillerService,
    private http: HttpClient,
  ) {
    this.toolbar.init(this.activatedRoute);
  }

  public ngOnInit() {
    this.activatedRoute.data.subscribe((data: { automaticReadingResult: AutomaticReadingResultData }) => {
      var automaticReadingData = data.automaticReadingResult;
      this.validateReadingStatus(automaticReadingData);
      this.liabilityAutomaticReadingId = automaticReadingData.liabilityAutomaticReadingId;
      this.showManual = (automaticReadingData.readingStatus === ReadingStatus.ERROR) ||
        automaticReadingData.billerId === null || automaticReadingData.amountToPay === null || automaticReadingData.bban === null;

      if (this.showManual) {
        this.title = 'Uzupełnij i zweryfikuj';
        this.subtitle = 'Nie udało nam się odczytać wszystkich danych z przesłanego dokumentu. ' +
          'Uzupełnij i sprawdź poprawność  informacji.';
      }

      this.url = encodeURIComponent(automaticReadingData.path);
      this.path = automaticReadingData.path;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.path);
      this.foundBiller = automaticReadingData.biller;
    });

  }

  public validateReadingStatus(data: AutomaticReadingResultData): void {
    if (data.readingStatus === ReadingStatus.PROCESSING) {
      this.navigateToLiabilities('reading', data.liabilityId);
    } else if (data.readingStatus === ReadingStatus.DONE) {
      this.navigateToLiabilities('scan-completed', data.liabilityId);
    } else {
      this.fillForm(data);
    }
  }

  public fillForm(data: AutomaticReadingResultData): void {
    this.initialManualDataValue = {
      customerId: null,
      nip: data.nip,
      billerId: data.billerId,
      biller: data.biller,
      amount: data.amountToPay,
      amountToPay: data.amountToPay,
      bban: data.bban,
      title: data.title,
      paymentDue: data.paymentDue,
    };
    this.form = new AddLiabilityScanForm(
      this.MIN_AMOUNT,
      this.appConfig.config.liabilityAmountLimit,
      data.amountToPay,
      data.bban,
      data.title,
      data.paymentDue,
      data.billerId,
      data.biller,
      data.nip,
    );
    this.initCustomerBillers();
  }

  public addBiller(): void {
    this.dialog
      .open(AddBillerDialogComponent, {
        maxWidth: MAX_WIDTH_90,
        width: WIDTH_360,
        data: this.foundBiller,
      })
      .afterClosed()
      .pipe(
        tap(({ billerId, customerBillerId, displayName }) => {
          if (customerBillerId) {
            this.pushAndSetValue({ billerId, customerBillerId, displayName });
          } else {
            this.customerBillers = this.customerBillers.filter((biller) => biller.customerBillerId !== '0');
            this.pushAndSetValue({ billerId, customerBillerId: '0', displayName });
          }
        }),
      )
      .subscribe();
  }

  public submit = () => {
    if (this.form.invalid) {
      return of();
    }

    const tempBiller = this.customerBillers.find(
      (biller) => biller.customerBillerId === '0' && biller.customerBillerId === this.form.customerBillerId.value,
    );
    if (tempBiller && tempBiller.billerId) {
      return this.addCustomerBillerOnSubmit(tempBiller);
    } else if (tempBiller && !tempBiller.billerId) {
      return this.addBillerOnSubmit(tempBiller.displayName);
    }

    return this.liabilityService
      .addLiabilityFromAutomaticReading(this.liabilityAutomaticReadingId, this.form.getFinalData())
      .pipe(switchMap((data) => this.navigateToLiabilities('scan-completed', data)));
  };

  private initCustomerBillers(): void {
    const liabilityLimitedSources = [LiabilitySource.EMAIL_FORWARD, LiabilitySource.MANUAL_SCANNING,
      LiabilitySource.MANUAL];
    this.customerBillerStoreService
      .getCustomerBillersWithSources(liabilityLimitedSources)
      .pipe(
        take(1),
        tap((customerBillers: LimitedCustomerBiller[]) => (this.customerBillers = customerBillers)),
        tap(() => this.findCustomerBiller()),
      )
      .subscribe();
  }

  private findCustomerBiller(): void {
    if (this.foundBiller) {
      const foundCustomerBiller = this.customerBillers.find(
        (customerBiller) => customerBiller.displayName.toLowerCase() === this.foundBiller.toLocaleLowerCase(),
      );
      if (foundCustomerBiller) {
        this.form.customerBillerId.setValue(foundCustomerBiller.customerBillerId);
      } else {
        this.pushAndSetValue({ billerId: null, customerBillerId: null, displayName: this.foundBiller });
      }
    }
  }

  private navigateToLiabilities(...args: string[]): Promise<boolean> {
    return this.router.navigate([`liabilities/${args.join('/')}`]);
  }

  private addBillerOnSubmit(biller: string): Observable<string> {
    return this.billerService.addBiller(biller).pipe(
      switchMap((result: string) =>
        this.addCustomerBillerOnSubmit({
          billerId: result,
          displayName: result,
          customerBillerId: null,
        }),
      ),
    );
  }

  private addCustomerBillerOnSubmit(biller: LimitedCustomerBiller): Observable<any> {
    return this.customerBillerStoreService.addCustomerBiller(biller.billerId).pipe(
      switchMap((customerBillerId: string) => {
        this.overrideCustomerBillerId(customerBillerId);
        this.form.customerBillerId.setValue(customerBillerId);
        return this.customerBillerStoreService.updateLiabilitySource(customerBillerId, LiabilitySource.MANUAL);
      }),
      switchMap(() =>
        this.liabilityService.addLiabilityFromAutomaticReading(
          this.liabilityAutomaticReadingId,
          this.form.getFinalData(),
        ),
      ),
      tap((data) => this.navigateToLiabilities('scan-completed', data)),
    );
  }

  private pushAndSetValue({ billerId, customerBillerId, displayName }) {
    this.customerBillers.push({
      billerId,
      customerBillerId,
      displayName,
    });
    this.form.customerBillerId.setValue(customerBillerId);
  }

  private overrideCustomerBillerId(newCustomerBillerId: string) {
    const biller = this.customerBillers.find((biller) => biller.customerBillerId === '0');
    if (biller) {
      biller.customerBillerId = newCustomerBillerId;
    }
  }

  public onShowManual(data: { title: string, subtitle: string }) {
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.showManual = true;
  }

  showFile() {
    if (this.base64Src) {
      this.base64Src = null;
      this.maxWidth = '516px';
    } else {
      this.maxWidth = '1116px';
      this.fetchFile()
        .subscribe((response: ArrayBuffer) => {
            this.base64Src = this.convertToBase64(response);
          },
          (error) => {
            console.error('Błąd podczas pobierania pliku:', error);
          },
        );
    }
  }

  private convertToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  showFileOnNewScreen() {
    this.base64Src = null;
    this.maxWidth = '516px';
    this.documentPreviewVisible = !this.documentPreviewVisible;
  }

  private fetchFile(): Observable<ArrayBuffer>{
    return this.http.get(this.path, { responseType: 'arraybuffer' });
  }

  downloadFile() {
    this.fetchFile()
      .subscribe(
        (response: ArrayBuffer) => {
          const base64Data = this.convertToBase64(response);
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          const link = document.createElement('a');
          const url =  URL.createObjectURL(blob);
          link.href = url;
          link.download = this.liabilityAutomaticReadingId + '.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Błąd podczas pobierania pliku:', error);
        }
      );
  }
  blockEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onTouchStart(event: TouchEvent) {
    this.touchTimeout = setTimeout(() => {
      event.preventDefault();
    }, 500); // 500ms – czas rozpoznawania long press w iOS
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onTouchEnd(event: TouchEvent) {
    clearTimeout(this.touchTimeout);
  }

}
